/*
 * PDF Widget
 * Author: Benj
 */
;(function ($, window, document, undefined) {

    var dataKey = "plugin_pdfWidget";

    var Plugin = function (element, options) {

        this.element = element;

        this.options = {
            url: '',
            scale: 1,
            canvas: '.pdf-canvas',
            prev: '.pdf-prev',
            next: '.pdf-next',
            loadingClass: 'pdf-loading',
            count: '',
            scaleHeight: true,
        };

        this.init(options);
    };

    Plugin.prototype = {
        init: function (options) {
            options = $.extend(this.options, options);

            /**
             * Next/Prev Page Example
             * @type {null}
             */
                // var url = 'https://cdn2.hubspot.net/hubfs/2992302/KIP_WEBSITE_ASSETS/KIP_NA_WEBSITE_ASSETS/PMO%20Strategies%20-%20Beyond%20Project%20Delivery.pdf';
            var url = options.url;

            var pdfDoc = null,
                pageNum = 1,
                pageRendering = false,
                pageNumPending = null,
                scale = 1,
                container = this.element,
                canvas = this.element.find(options.canvas),
                prevBtn = container.find(options.prev),
                nextBtn = container.find(options.next);

            loadingPdf(true);

            var ctx = canvas[0].getContext('2d');

            // Loaded via <script> tag, create shortcut to access PDF.js exports.
            var pdfjsLib = window['pdfjs-dist/build/pdf'];

            // The workerSrc property shall be specified.
            pdfjsLib.GlobalWorkerOptions.workerSrc = '//mozilla.github.io/pdf.js/build/pdf.worker.js';
            //pdfjsLib.GlobalWorkerOptions.workerSrc = '//mozilla.github.io/pdf.js/es5/build/pdf.worker.js';

            /**
             * Get page info from document, resize canvas accordingly, and render page.
             * @param num Page number.
             */
            function renderPage(num) {
                pageRendering = true;

                // Using promise to fetch the page
                pdfDoc.getPage(num).then(function(page) {
                    var viewport = page.getViewport({scale: 1});
                    var windowHeight = $(window).height();
                    var scaleW = container.width() / viewport.width;
                    if (options.scaleHeight && windowHeight > 300) {
                        var scaleH = (windowHeight * 0.95) / viewport.height;
                        scale = Math.min(scaleW, scaleH);
                    } else {
                        scale = scaleW;
                    }

                    viewport = page.getViewport({scale: scale});
                    canvas[0].width = viewport.width;
                    canvas[0].height = viewport.height;

                    // Render PDF page into canvas context
                    var renderContext = {
                        canvasContext: ctx,
                        viewport: viewport
                    };
                    var renderTask = page.render(renderContext);

                    // Wait for rendering to finish
                    renderTask.promise.then(function() {
                        loadingPdf(false);

                        pageRendering = false;
                        if (pageNumPending !== null) {
                            // New page rendering is pending
                            renderPage(pageNumPending);
                            pageNumPending = null;
                        }
                    });
                });

                updateCount(num);

                syncBtns(num);
            }

            /**
             * If another page rendering in progress, waits until the rendering is
             * finised. Otherwise, executes rendering immediately.
             */
            function queueRenderPage(num) {
                if (pageRendering) {
                    pageNumPending = num;
                } else {
                    renderPage(num);
                }
            }

            /**
             * Displays previous page.
             */
            function prevPage() {
                if (pageNum <= 1) {
                    return;
                }
                pageNum--;
                queueRenderPage(pageNum);
            }
            prevBtn.on('click', prevPage);

            /**
             * Displays next page.
             */
            function nextPage() {
                if (pageNum >= pdfDoc.numPages) {
                    return;
                }
                pageNum++;
                queueRenderPage(pageNum);
            }
            nextBtn.on('click', nextPage);

            /**
             * Shortboard Shortcuts
             */
            $(document).keydown(function(e) {
                switch(e.which) {
                    case 37: // left
                    case 38: // up
                        prevBtn.focus();
                        prevPage();
                        setTimeout(function() {
                            prevBtn.blur();
                        },200)
                        break;

                    case 39: // right
                    case 40: // down
                        nextBtn.focus();
                        nextPage();
                        setTimeout(function() {
                            nextBtn.blur();
                        },200)
                        break;

                    default: return; // exit this handler for other keys
                }
                e.preventDefault(); // prevent the default action (scroll / move caret)
            });

            /**
             * Swipe Left/Right
             */
            canvas.on('swiperight', function() {
                prevBtn.focus();
                prevPage();
                setTimeout(function() {
                    prevBtn.blur();
                },200)
            });

            canvas.on('swipeleft', function() {
                nextBtn.focus();
                nextPage();
                setTimeout(function() {
                    nextBtn.blur();
                },200)
            });

            /**
             * Improve swiping
             */
            canvas.on('mousedown touchmove', function () {
                canvas.addClass('swipping');
            }).on('mouseup touchend touchcancel', function () {
                canvas.removeClass('swipping');
            });

            /**
             * Update Page Count
             * @param int pageNum
             */
            function updateCount(pageNum) {
                if (options.count) {
                    container.find(options.count).text(pageNum);
                }
            }

            /**
             * Sync Buttons
             * @param int pageNum
             */
            function syncBtns(pageNum) {
                // First page
                prevBtn.toggleClass('hide', (pageNum == 1));

                // Last page
                nextBtn.toggleClass('hide', (pageNum >= pdfDoc.numPages));
            }

            function loadingPdf(loadingState) {
                container.toggleClass(options.loadingClass, loadingState);
            }

            /**
             * Asynchronously downloads PDF.
             */
            var loadingTask = pdfjsLib.getDocument(url);
            loadingTask.promise.then(function(pdfDoc_) {
                pdfDoc = pdfDoc_;

                // Initial/first page rendering
                renderPage(pageNum);
            }).catch(function(e){
                console.error(e, e.stack);
                loadingPdf(false);
                container.find('.pdf-canvas-inner').append('<div>There was an error loading your resource.</div>');
            });

        }
    };

    /*
     * Plugin wrapper, preventing against multiple instantiations and
     * return plugin instance.
     */
    $.fn.pdfWidget = function (options) {

        var plugin = this.data(dataKey);

        // has plugin instantiated ?
        if (plugin instanceof Plugin) {
            // if have options arguments, call plugin.init() again
            if (typeof options !== 'undefined') {
                plugin.init(options);
            }
        } else {
            plugin = new Plugin(this, options);
            this.data(dataKey, plugin);
        }

        return plugin;
    };

}(jQuery, window, document));
